var DATA_HOOKS = /* @__PURE__ */ ((DATA_HOOKS2) => {
  DATA_HOOKS2["FORM_ROOT"] = "form-root";
  DATA_HOOKS2["FORM_VIEWER_NO_FORM_ERROR"] = "form-viewer-no-form-error";
  DATA_HOOKS2["SUBMIT_THANK_YOU_MESSAGE"] = "submit-form-success-message";
  DATA_HOOKS2["SUBMIT_ERROR_MESSAGE"] = "submit-form-error-message";
  return DATA_HOOKS2;
})(DATA_HOOKS || {});
export {
  DATA_HOOKS
};
//# sourceMappingURL=data-hooks.js.map
